import { Component, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { UtilisateursService } from '../../services/utilisateurs.service';
import { tap } from 'rxjs';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

Chart.register(...registerables);

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css'],
})
export class StatisticsComponent implements OnInit {
  chart: any;
  dataByCategorie!: any;
  femaleBycategoryIA: number[] = [];
  maleBycategoryIA: number[] = [];
  femaleBycategoryDEV: number[] = [];
  maleBycategoryDEV: number[] = [];
  femaleBycategoryEB: number[] = [];
  maleBycategoryEB: number[] = [];
  femaleBycategoryTECYB: number[] = [];
  maleBycategoryTECYB: number[] = [];
  cohorte!: any;

  constructor(
    private utilisateurService: UtilisateursService,
    private spinner: SpinnerServiceService
  ) {}

  ngOnInit(): void {
    this.cohorte = sessionStorage.getItem('cohorte');
    this.utilisateurService
      .getCandidatureStatistics(this.cohorte)
      .pipe(
        tap(() => this.spinner.showSpinner()),
        tap((stats) => {
          //// //console.log(stats);
          stats.familyStatsList.forEach((family) => {
            if (family.familyName === 'INTELLIGENCE ARTIFICIELLE ET DATA') {
              family.categoryStatsList.forEach((category) => {
                this.femaleBycategoryIA.push(category.femaleNumber);
                this.maleBycategoryIA.push(category.maleNumber);
              });

              this.setDiagrams(
                'canvasIA',
                this.maleBycategoryIA,
                this.femaleBycategoryIA,
                family.familyName,
                {
                  homme: 'rgba(230, 134, 33, 0.7)',
                  femme: 'rgba(13, 160, 64, 0.7)',
                }
              );
            }

            if (family.familyName === 'DÉVELOPPEMENT LOGICIEL') {
              family.categoryStatsList.forEach((category) => {
                this.femaleBycategoryDEV.push(category.femaleNumber);
                this.maleBycategoryDEV.push(category.maleNumber);
              });

              this.setDiagrams(
                'canvasDL',
                this.maleBycategoryDEV,
                this.femaleBycategoryDEV,
                family.familyName,
                {
                  homme: 'rgba(8, 113, 184, 0.7)',
                  femme: 'rgba(230, 134, 33, 0.7)',
                }
              );
            }

            if (family.familyName === 'e-BUSINESS') {
              family.categoryStatsList.forEach((category) => {
                this.femaleBycategoryEB.push(category.femaleNumber);
                this.maleBycategoryEB.push(category.maleNumber);
              });

              this.setDiagrams(
                'canvasEB',
                this.maleBycategoryEB,
                this.femaleBycategoryEB,
                family.familyName,
                {
                  homme: 'rgba(8, 113, 184, 0.7)',
                  femme: 'rgba(13, 160, 64, 0.7)',
                }
              );
            }
            if (
              family.familyName === 'TECHNOLOGIES EMERGENTES ET CYBERSECURITE'
            ) {
              family.categoryStatsList.forEach((category) => {
                this.femaleBycategoryTECYB.push(category.femaleNumber);
                this.maleBycategoryTECYB.push(category.maleNumber);
              });

              this.setDiagrams(
                'canvasTECYB',
                this.maleBycategoryTECYB,
                this.femaleBycategoryTECYB,
                family.familyName,

                {
                  homme: 'rgba(230, 134, 33, 0.7)',
                  femme: 'rgba(8, 113, 184, 0.7)',
                }
              );
            }
          });

          //// //console.log(this.femaleBycategoryDEV);
          //// //console.log(this.maleBycategoryDEV);
        })
      )
      .subscribe();
  }

  setDiagrams(
    canvasName: string,
    maleData: number[],
    femaleData: number[],
    title: string,
    color: { homme: string; femme: string }
  ) {
    const canvas = document.getElementById(canvasName) as HTMLCanvasElement;

    const ctxIA = canvas.getContext('2d');
    if (ctxIA) {
      //// //console.log(ctxIA);
      this.chart = new Chart(ctxIA, {
        type: 'bar',
        data: {
          labels: [
            'Diplômés (> Bac)',
            'Etudiants en fin de cycle',
            'Bacheliers sans emploi',
            'Salariés, Freelance, non diplômé',
            'Etudiants en début de cycle',
            'BFEM/CAP/CFEE',
          ], // Labels principaux
          datasets: [
            {
              label: 'Homme',
              data: maleData,
              backgroundColor: color.homme,
            },
            {
              label: 'Femme',
              data: femaleData,
              backgroundColor: color.femme,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: {
              stacked: true,
            },
            y: {
              stacked: true,
            },
          },
        },
      });
    }
  }
}
